import { UpdatableModel } from 'projects/common/src/lib/models/updatable-model';

export class FirmAvailable extends UpdatableModel<FirmAvailable> {
  id: string;
  name: string;
  licenseNumber: string;
  isSwitch: boolean;
}
